/*
================================================================================
File: src/api/axios.js
Description: Centralized Axios configuration for API requests.
================================================================================
*/
import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://app.bigdogtools.com/sites',
  timeout: 60000,
  headers: {
    'Content-Type': 'multipart/form-data',
    'Accept': 'application/json',
  },
});

export default instance;
